"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlatform = void 0;
const getPlatform = () => {
    const platform = window.navigator.platform, userAgent = window.navigator.userAgent.toLowerCase(), browser = /safari/.test(userAgent) || /chrome/.test(userAgent) || /firefox/.test(userAgent), touchDevice = /iphone|ipod|ipad|Android/.test(userAgent);
    return {
        platform,
        userAgent,
        browser,
        touchDevice
    };
};
exports.getPlatform = getPlatform;
